<page-title [title]="title"></page-title>
<p>Navegue pelas abas para visualizar os especialistas, clique para ver mais detalhes.</p>

<mat-tab-group>
  <!-- 🔹 Ativos -->
  <mat-tab label="Ativos">
    <ng-container *ngIf="practitionerActive.length > 0; else noActivePractitioner">
      <div class="col-xs-12 col-lg-6" *ngFor="let practitioner of practitionerActive">
        <mat-card (click)="openPractitionerDetailForm(practitioner, 'accepted')">
          <div class="card-content">
            <div class="photo">
              <img [src]="getPractitionerPhoto(practitioner.practitioner_id)" alt="practitionerPhoto" />
            </div>
            <div class="text">
              {{ practitioner.practitioner_name }} <br />
              {{ practitioner.healthcareservice_name }} <br />
              {{ getAddress(practitioner.practitioner_details) }}
            </div>
          </div>
        </mat-card>
      </div>
    </ng-container>
    <ng-template #noActivePractitioner>
      <div class="empty-message">
        Nenhum especialista ativo encontrado.
      </div>
    </ng-template>
  </mat-tab>

  <!-- 🔹 Inativos -->
  <mat-tab label="Inativos">
    <ng-container *ngIf="practitionerInactive.length > 0; else noInactivePractitioner">
      <div class="col-xs-12 col-lg-6" *ngFor="let practitioner of practitionerInactive">
        <mat-card (click)="openPractitionerDetailForm(practitioner, 'cancelled')">
          <div class="card-content">
            <div class="text">
              {{ practitioner.practitioner_name }} <br />
              {{ practitioner.healthcareservice_name }} <br />
              {{ getAddress(practitioner.practitioner_details) }}
            </div>
            <div class="photo">
              <img [src]="getPractitionerPhoto(practitioner.practitioner_id)" alt="practitionerPhoto" />
            </div>
          </div>
        </mat-card>
      </div>
    </ng-container>
    <ng-template #noInactivePractitioner>
      <div class="empty-message">
        Nenhum especialista inativo encontrado.
      </div>
    </ng-template>
  </mat-tab>

  <!-- 🔹 Pendente aprovação -->
  <mat-tab label="Pendente aprovação">
    <ng-template mat-tab-label>
      Aprovação
      <div matBadge="" class="c-badge"></div>
    </ng-template>

    <ng-container *ngIf="practitionerPending.length > 0; else noPendingPractitioner">
      <div class="col-xs-12 col-md-4" *ngFor="let practitioner of practitionerPending">
        <mat-card (click)="openPractitionerDetailForm(practitioner, 'requested')">
          <div class="card-content">
            <div class="text">
              {{ practitioner.practitioner_name }} <br />
              {{ practitioner.healthcareservice_name }} <br />
              {{ getAddress(practitioner.practitioner_details) }}
            </div>
            <div class="photo">
              <img [src]="getPractitionerPhoto(practitioner.practitioner_id)" alt="practitionerPhoto" />
            </div>
          </div>
        </mat-card>
      </div>
    </ng-container>
    <ng-template #noPendingPractitioner>
      <div class="empty-message">
        Nenhum especialista pendente de aprovação encontrado.
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<div class="actions">
  <button
    mat-flat-button
    color="primary"
    (click)="openPractitionerRegistration()"
    [disabled]="loading"
  >
    Cadastrar
  </button>
</div>
